import styles from "./Footer.module.css";
import logo from "../../assets/images/logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import {
  visaIcon,
  masercardIcon,
  paypalIcon,
  americanExpressIcon,
  googlePayIcon,
  applePay,
} from "../../assets/svg/paymenticons";
import {
  facebook,
  instagram,
  linkedin,
  youtube,
} from "../../assets/svg/footerbtnhs";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoPath = () => {
    if (location.pathname !== "/") {
      navigate("/");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top
    }
  };

  const handleEmailClick = () => {
    const recipient = "grids@matchmovemachine.com";
    window.location.href = `mailto:${recipient}`;
  };
  return (
    <footer className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logoCont} onClick={handleLogoPath}>
          <img src={logo} alt="Matchmove machine" />
        </div>
        <div className={styles.menu}>
          <div className={styles.column}>
            <p className="h5-extra-bold">Menu</p>
            <ul>
              <li>
                <a href="/">Library</a>
              </li>
              <li>
                <a href="/how-it-works">How it works</a>
              </li>
              <li>
                <a href="/grid-cost-calculator">Cost calculator</a>
              </li>
              <li>
                <a href="/affiliate-program">Affiliate program</a>
              </li>
              <li>
                <a href="/tutorials">Tutorials</a>
              </li>
              <li>
                <a href="https://matchmovemachine.com/howto" target="_blank" rel="noopener noreferrer">Shooting guide</a>
              </li>
              <li>
                <a href="https://matchmovemachine.com/grid/" target="_blank" rel="noopener noreferrer">Distortion grid</a>
              </li>
              <li>
                <a href="/faq">FAQ</a>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.line}>
          <div className={styles.lineCont} />
        </div>

        <div className={styles.wrap}>
          <div className={styles.links}>
            <div className={styles.column}>
              <p className="h5-extra-bold">Links</p>
              <ul>
                <li>
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                    Privacy policy
                  </a>
                </li>
                <li>
                  <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">
                    Terms of use
                  </a>
                </li>
                <li>
                  <a href="https://matchmovemachine.com/" target="_blank" rel="noopener noreferrer">
                    Our studio
                  </a>
                </li>
                <li>
                  <a href="https://camdb.matchmovemachine.com" target="_blank" rel="noopener noreferrer">
                    Camera database
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.line}>
            <div className={styles.lineCont} />
          </div>

          <div className={styles.payments}>
            <div className={styles.column}>
              <p className="h5-extra-bold">Payments</p>
              <ul>
                <li>
                  <button>{visaIcon}</button>
                </li>
                <li>
                  <button>{masercardIcon}</button>
                </li>
                <li>
                  <button>{paypalIcon}</button>
                </li>
                <li>
                  <button>{americanExpressIcon}</button>
                </li>
                <li>
                  <button>{googlePayIcon}</button>
                </li>
                <li>
                  <button>{applePay}</button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.line}>
          <div className={styles.lineCont} />
        </div>

        <div className={styles.item}>
          <div className={styles.contacts}>
            <div className={styles.column}>
              <p className="h5-extra-bold">Contacts</p>
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/company/matchmovemachine/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>{linkedin}</button>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@matchmovemachine"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>{youtube}</button>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/matchmovemachine"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>{instagram}</button>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/matchmovemachine"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>{facebook}</button>
                  </a>
                </li>
              </ul>
            </div>

            <div className={styles.email}>
              <p className="h5-extra-bold">Email</p>
              <p
                onClick={handleEmailClick}
                className={styles.highLight}
                style={{cursor: 'pointer'}}
              >
                grids@matchmovemachine.com
              </p>
            </div>
          </div>
        </div>
      </div>
      <div style={{ background: '#121212', height: '53px', width: '100%' }}>
  <p className="h2-light" style={{ marginTop: '15px', textAlign: 'center', fontSize: '18px', color: 'white' }}>
    © Matchmove machine, {new Date().getFullYear()}
  </p>
</div>
    </footer>
  );
};

export default Footer;
